"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.obtenerDatosValidacionIdentidad = exports.guardarDatosValidacionIdentidad = exports.verificarEstadoValidacionIdentidad = exports.iniciarValidacionIdentidad = exports.handleError = exports.handleResponse = void 0;
// Funciones para validación de datos
// @ts-ignore
const ajaxUrl = front_page.ajax_url;
const axios_1 = __importDefault(require("axios"));
// Manejadores de respuestas y errores de axios
const handleResponse = (response) => {
    if (response.status >= 200 && response.status < 300) {
        return response.data;
    }
    else {
        if (response.data) {
            return response.data;
        }
        return false;
    }
};
exports.handleResponse = handleResponse;
const handleError = (error) => {
    // @ts-ignore
    if (axios_1.default.isAxiosError(error) && error.response) {
        return error.response.data;
    }
    return false;
};
exports.handleError = handleError;
const iniciarValidacionIdentidad = (datos) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const formData = new FormData();
        formData.append('action', 'iniciarValidacionIdentidad');
        formData.append('docFrontal[base64]', datos.fotoDocFrontal);
        formData.append('docFrontal[capturado]', datos.fechaHoraInicioString);
        formData.append('docPosterior[base64]', datos.fotoDocPosterior);
        formData.append('docPosterior[capturado]', datos.fechaHoraInicioString);
        formData.append('uuidUser', datos.uuidUser);
        formData.append('documento', datos.documento);
        console.log(datos.documento);
        // @ts-ignore
        const response = yield axios_1.default.post(ajaxUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return (0, exports.handleResponse)(response);
    }
    catch (error) {
        return (0, exports.handleError)(error);
    }
});
exports.iniciarValidacionIdentidad = iniciarValidacionIdentidad;
const verificarEstadoValidacionIdentidad = () => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData();
    formData.append('action', 'verificarEstadoValidacionIdentidad');
    try {
        // @ts-ignore
        const response = yield axios_1.default.post(ajaxUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return (0, exports.handleResponse)(response);
    }
    catch (error) {
        return (0, exports.handleError)(error);
    }
});
exports.verificarEstadoValidacionIdentidad = verificarEstadoValidacionIdentidad;
const guardarDatosValidacionIdentidad = (datos) => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData();
    formData.append('action', 'guardarDatosValidacionIdentidad');
    formData.append('uuidUser', datos.uuidUser);
    formData.append('status', datos.status);
    try {
        // @ts-ignore
        const response = yield axios_1.default.post(ajaxUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return (0, exports.handleResponse)(response);
    }
    catch (error) {
        return (0, exports.handleError)(error);
    }
});
exports.guardarDatosValidacionIdentidad = guardarDatosValidacionIdentidad;
const obtenerDatosValidacionIdentidad = () => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData();
    formData.append('action', 'obtenerDatosValidacionIdentidad');
    try {
        // @ts-ignore
        const response = yield axios_1.default.post(ajaxUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return (0, exports.handleResponse)(response);
    }
    catch (error) {
        return (0, exports.handleError)(error);
    }
});
exports.obtenerDatosValidacionIdentidad = obtenerDatosValidacionIdentidad;
